import { useContext } from "react";
import { SelectableTextContext, WebEditorContext } from "../../../../contexts";
import _ from "lodash";
import TextHoverComponent from "./TextHoverComponent";

export default function TextPartComponent({ editorTextPart, filter, inSidebarDialog }) {
    const { selectedTextPartIdRef, setHoveredSelectableText } = useContext(SelectableTextContext);
    const { autoSaveEditorFile, formikValuesRef, onInputFieldChange } = useContext(WebEditorContext);
    const inputId = `${inSidebarDialog ? 'dialog-' : ''}predefined-input-${editorTextPart.Id}`;

    const handleChange = async (value) => {
        onInputFieldChange({
            target: {
                name: editorTextPart.Id,
                value: value,
            }
        });
        editorTextPart.Visible = value;
        formikValuesRef.current[editorTextPart.Id] = value;

        if (value) {
            selectedTextPartIdRef.current = editorTextPart.Id;
        } else {
            selectedTextPartIdRef.current = null;

            setHoveredSelectableText(null);
        }

        autoSaveEditorFile();
    }

    const isVisible = () => {
        editorTextPart.Keywords = editorTextPart.Keywords || [];

        let checkOnNoKeyword = editorTextPart.Keywords?.length === 0 && filter.keywords.includes("<Blanke>");
        let hasKeyWord = checkOnNoKeyword || editorTextPart.Keywords?.some(k => filter.keywords.includes(k));

        return editorTextPart?.Description?.toLowerCase().includes(filter.search.toLowerCase()) && hasKeyWord;
    }

    const handleMouseEnter = () => {
        selectedTextPartIdRef.current = null;

        const clonedEditorTextPart = _.cloneDeep(editorTextPart);
        clonedEditorTextPart.Visible = true;
        setHoveredSelectableText(clonedEditorTextPart);
    }

    const handleMouseLeave = () => {
        setHoveredSelectableText(null);
    }

    return (
        isVisible() &&
        <TextHoverComponent
            cssClass="tw-relative tw-border tw-rounded-md tw-shadow-sm tw-px-3 sm:tw-px-6 tw-py-2 tw-flex tw-rounded hover:tw-bg-gray-200"
            onMouseEnter={() => handleMouseEnter()}
            onMouseLeave={() => handleMouseLeave()}
        >
            <div className="tw-flex tw-items-center tw-h-5">
                <input
                    id={inputId}
                    type="checkbox"
                    name={`single-checkbox-${inputId}`}
                    className="focus:tw-ring-indigo-700 tw-h-4 tw-w-4 tw-text-indigo-700 tw-cursor-pointer tw-border-gray-300"
                    checked={editorTextPart.Visible}
                    onChange={(e) => handleChange(e.target.checked)}
                />
            </div>
            <label
                htmlFor={`single-checkbox-${inputId}`}
                className="tw-ml-3 tw-w-full tw-flex tw-flex-col tw-cursor-pointer tw-text-gray-900 tw-text-sm tw-font-medium tw-overflow-x-hidden tw-break-words"
                onClick={(e) => handleChange(_.clone(!editorTextPart.Visible))}
            >
                {editorTextPart.Description}
            </label>
        </TextHoverComponent>
    )
}